<template>
  <li :class="classnames" :title="`${help ? help : ''}`">
    <div class="dashboard-tile-social" v-if="social">
      <i :class="'dashboard-tile__icon icon--social-' + social">
        <span class="hide--visually">{{ social }}</span>
      </i>
    </div>
    <div class="dashboard-tile-top">
      <span class="dashboard-tile__category"
        :class="{ 'dashboard-tile__category--full': metric === false }"
      >
        {{ mutatedName(name) }}
      </span>
      <span class="dashboard-tile__metric"
        v-if="metric"
        :class="{ 'dashboard-tile__metric--positive': roundedDifference > 0, 'dashboard-tile__metric--negative': roundedDifference < 0 }"
      >
        <span v-if="roundedDifference === 0">
          &mdash;
        </span>
        <span v-else>{{ direction }}<i-count-up
            :start="0"
            :end="roundedDifference"
            :decimals="0"
            :duration="0.5"
            :options="countUpPercent"
          ></i-count-up>
        </span>
      </span>
    </div>
    <p class="dashboard-tile__total" v-if="isNumeric(amount)">
      <i-count-up
        :start="0"
        :end="amount"
        :decimals="type == 'money' ? 2 : 0"
        :duration="0.5"
        :options="findOption(type)"
      ></i-count-up>
    </p>
    <p class="dashboard-tile__total" v-else>{{ amount }}</p>
  </li>
</template>

<script>
  import _forOwn from 'lodash/forOwn'
  import ICountUp from 'vue-countup-v2'

  import { bem } from '@/mixins/bem.js'
  import { tile } from '@/mixins/tile.js'

  const namespace = 'dashboard-tile__item'

  export default {
    name: 'DashboardTile',
    components: {
      'i-count-up': ICountUp
    },
    mixins: [ bem, tile ],
    props: {
      displayName: {
        type: String
      },
      help: {
        default: null,
        type: String
      },
      metric: {
        default: true,
        type: Boolean
      },
      social: {
        default: null,
        type: String
      }
    },
    data: function () {
      return {
        revealCategoryText: false
      }
    },
    computed: {
      roundedDifference: function () {
        return Math.round(this.difference)
      }
    },
    created: function () {
      this.setNamespace(namespace)
    },
    methods: {
      mutatedName: function (itemName) {
        let mutatedName = itemName

        const replacements = {
          'Avg': 'Avg.',
          'Average': 'Avg.'
          // 'Percentage': '%'
        }

        _forOwn(replacements, function (replacement, replacementName) {
          mutatedName = mutatedName.replace(replacementName, replacement)
        })

        return mutatedName
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/DashboardTile.vue